<style scoped>
/* Styles remain the same */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

.action-btn-spacing {
  margin-left: 8px;
}
</style>

<template>
<div class="prefix_maps">
    <!-- Main Data Table for Prefix Maps -->
    <v-data-table
        :headers="map_headers"
        :items="maps"
        :search="search"
        sort-by="id"
        class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title><h2 class="br">Prefix Maps</h2></v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Add Prefix Map Dialog -->
                <v-dialog v-model="dialog_map" max-width="500px">
                    <template v-slot:activator="{ props }">
                        <v-btn @click="new_map" color="primary" dark class="mb-2 action-btn-spacing" v-bind="props">
                            Add Prefix Map
                        </v-btn>
                    </template>
                    <ValidationObserver ref="observer_map" v-slot="{ invalid }">
                        <v-card>
                            <v-form>
                                <v-card-title>
                                    <span class="headline">{{ map_form_title }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container style="max-height: 520px; overflow-y: auto;">
                                        <v-row>
                                            <v-col cols="12">
                                                <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                                    <v-text-field
                                                        v-model="edited_map.id"
                                                        label="Prefix Map ID"
                                                    ></v-text-field>
                                                    <span class="required_err">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12">
                                                 <ValidationProvider rules="required" v-slot="{ errors }">
                                                     <v-select
                                                        v-model="edited_map.type"
                                                        :items="['ipv4', 'ipv6']"
                                                        label="Map Type"
                                                    ></v-select>
                                                    <span class="required_err">{{ errors[0] }}</span>
                                                 </ValidationProvider>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close_map_dialog">Cancel</v-btn>
                                    <v-btn color="blue darken-1" :disabled="invalid" text @click="save_map">Save</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </ValidationObserver>
                </v-dialog>

            </v-toolbar>
            <v-toolbar flat>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search Maps"
                    single-line
                    hide-details
                ></v-text-field>
            </v-toolbar>
        </template>

        <!-- Actions column for the Prefix Map table -->
        <template v-slot:item.actions="{ item }">
             <v-tooltip top>
                <template v-slot:activator="{ props }">
                     <v-icon small @click="delete_map(item)" v-bind="props">mdi-delete</v-icon>
                </template>
                <span>Delete Map '{{ item.id }}'</span>
             </v-tooltip>
        </template>

        <template v-slot:no-data>
            No prefix maps found.
        </template>
    </v-data-table>
</div>
</template>

<script>
import api_client from '../services/api.js';
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js";

export default {
    name: "prefix_maps",
    components: { ValidationProvider, ValidationObserver },
    data: () => ({
        search: '',
        dialog_map: false,
        map_headers: [
            { text: 'Map ID', value: 'id', align: 'start' },
            { text: 'Type', value: 'type' },
            { text: 'Actions', value: 'actions', sortable: false, align: 'end' },
        ],
        maps: [],
        edited_map_index: -1,
        edited_map: {
            id: '',
            type: 'ipv4', // Default type
        },
        default_map: {
            id: '',
            type: 'ipv4',
        },
    }),

    computed: {
        map_form_title() {
            return this.edited_map_index === -1 ? 'Add Prefix Map' : 'Prefix Map Details';
        },
    },

    watch: {
        dialog_map(val) { val || this.close_map_dialog() },
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            api_client.run_get_query('/prefix_map/show')
                .then(response => {
                    if (response.data.hasOwnProperty("err_msg") || 
                            !response.data.hasOwnProperty("prefix_maps")) {
                        this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                        return;
                    }
                    this.maps = response.data.prefix_maps;
                })
                .catch(error => {
                    console.error("Error fetching prefix maps:", error);
                    this.$fire({ title: "Error", text: "Could not load prefix maps.", type: "error" });
                    this.maps = [];
                });
        },

        new_map() {
            this.edited_map_index = -1;
            this.edited_map = Object.assign({}, this.default_map);
            this.$nextTick(() => {
                 if (this.$refs.observer_map) {
                    this.$refs.observer_map.reset();
                 }
            });
            this.dialog_map = true;
        },

        close_map_dialog() {
            this.dialog_map = false;
            this.$nextTick(() => {
                this.edited_map = Object.assign({}, this.default_map);
                this.edited_map_index = -1;
            });
        },

        save_map() {
            if (this.edited_map_index === -1) {
                const payload = {
                    map_id: this.edited_map.id,
                    type: this.edited_map.type
                };

                api_client.run_post_query('/prefix_map/create', payload)
                .then(response => {
                    if (response.data && response.data.hasOwnProperty("err_msg")) {
                        this.$fire({ title: "Command failed", text: response.data.err_msg, type: "warning" });
                        return;
                    }
                    this.maps.push({  
                        id: this.edited_map.id,
                        type: this.edited_map.type,
                    });
                    this.close_map_dialog();
                })
                .catch(error => {
                    console.error("Error creating prefix map:", error);
                    this.$fire({title: "Command failed", text: error, type: "error"});
                });
            }
        },

        delete_map(item) {
            this.edited_map_index = this.maps.indexOf(item);
            this.edited_map = Object.assign({}, item);
            this.$confirm(`Are you sure you want to delete the entire prefix map '${this.edited_map.id}'? This cannot be undone.`)
                .then((res) => {
                    if (res) {
                       this.delete_map_confirm();
                    }
                    else {
                        this.edited_map_index = -1;
                    }
                });
        },

        delete_map_confirm() {
            const payload = {
                map_id: this.edited_map.id
            };
            api_client.run_post_query('/prefix_map/destroy', payload)
            .then(response => {
                if (response.data && response.data.hasOwnProperty("err_msg")) {
                    this.$fire({ title: "Command failed", text: response.data.err_msg, type: "warning" });
                    return;
                }
                this.maps.splice(this.edited_map_index, 1);
            })
            .catch(error => {
                console.error("Error deleting prefix map:", error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            })
            .finally(() => {
                 this.edited_map_index = -1;
            });
        },
    }
};
</script>
